/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Einvoice_Pending_AgeInputs */

const vi_einvoice_pending_age = /** @type {(inputs: Einvoice_Pending_AgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Giao ${i?.days} ngày trước`)
};

/**

* @param {Einvoice_Pending_AgeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_pending_age = /** @type {((inputs: Einvoice_Pending_AgeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Pending_AgeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_pending_age(inputs)
});